import { estimateRatingFromCpl, type AnalyzedMove } from "@chessla/shared";
import { moveAccuracy } from "@/shared/utils/accuracy";

export function gamePerformance(moves: readonly AnalyzedMove[]) {
  const sides = {
    player: { totalLoss: 0, evaluatedMoves: 0, accuracyTotal: 0, accuracyMoves: 0 },
    opponent: { totalLoss: 0, evaluatedMoves: 0, accuracyTotal: 0, accuracyMoves: 0 },
  };
  for (const move of moves) {
    if (
      !Number.isFinite(move.centipawnLoss) ||
      move.centipawnLoss < 0 ||
      !(Number.isFinite(move.evalBeforeCp) || Number.isFinite(move.evalBeforeMate)) ||
      !(Number.isFinite(move.evalAfterCp) || Number.isFinite(move.evalAfterMate))
    )
      continue;
    const side = sides[move.isPlayerMove ? "player" : "opponent"];
    side.totalLoss += move.centipawnLoss;
    side.evaluatedMoves += 1;
    if (Number.isFinite(move.evalBeforeCp) && Number.isFinite(move.evalAfterCp)) {
      side.accuracyTotal += move.centipawnLoss === 0 ? 100 : moveAccuracy(move.evalBeforeCp!, move.evalAfterCp!);
      side.accuracyMoves += 1;
    }
  }
  const estimate = ({ totalLoss, evaluatedMoves, accuracyTotal, accuracyMoves }: typeof sides.player) => ({
    estimate: evaluatedMoves ? estimateRatingFromCpl(totalLoss / evaluatedMoves) : null,
    evaluatedMoves,
    accuracy: accuracyMoves ? accuracyTotal / accuracyMoves : null,
  });
  return { player: estimate(sides.player), opponent: estimate(sides.opponent) };
}
